module.exports = {

  title: '数勤通供应链系统',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * 主题类型
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  themeType: 'theme-theme3'
}



// WEBPACK FOOTER //
// ./src/settings.js